import { Component, inject } from "@angular/core";
import { environment } from "../../environment/environment";
import { TranslationService } from "../../services/translation.service";

@Component({
  selector: "app-footer",
  standalone: true,
  templateUrl: "./footer.component.html",
})
export class FooterComponent {
  protected appVersion = environment.appVersion;
  protected readonly i18n = inject(TranslationService);
}
